// Lib
import React, { useRef } from 'react';
import { stopDefaultAndPropagation } from '../../../../utils/domUtil';
import useSheet from '../../../../mobile/structural/sheet/hooks/useSheet';
import EmojiImage from '../../../emoji/EmojiImage';
import MobileCalloutEmojiSheet from './MobileCalloutEmojiSheet';
import { SheetId } from '../../../../mobile/structural/sheet/sheetTypes';
import { CalloutNodeViewIconProps } from './calloutNodeViewTypes';
import { useActiveTiptapEditorCallback } from '../../store/tiptapEditorStoreHooks';
import { convertUnifiedCodeToEmojiString } from '../../../../../common/emoji/emojiUtil';
import classNames from 'classnames';

const MobileCalloutNodeViewIcon: React.FC<CalloutNodeViewIconProps> = (props) => {
    const { node, updateAttributes, popupId } = props;

    const focusPosRef = useRef<number | null>(null);
    const sheetProps = useSheet(SheetId.ElementReactionTool, popupId);
    const { dispatchOpenSheet, dispatchCloseSheet } = sheetProps;

    const onEmojiClick = useActiveTiptapEditorCallback(
        (activeEditor, event: Event) => {
            event.stopPropagation();
            focusPosRef.current = activeEditor?.view?.hasFocus() ? activeEditor.view.state.selection.head : null;

            activeEditor?.commands?.blur();
            dispatchOpenSheet();
        },
        [dispatchOpenSheet],
    );

    const onSelectEmoji = useActiveTiptapEditorCallback((activeEditor, emojiId: string) => {
        const icon = convertUnifiedCodeToEmojiString(emojiId);
        updateAttributes({ icon, iconCode: emojiId });

        if (activeEditor && focusPosRef.current) {
            activeEditor.commands.focus(focusPosRef.current);

            // On iOS sometimes the focus would return to the start of the editor, so we try again after a frame
            requestAnimationFrame(() => {
                activeEditor.commands.focus(focusPosRef.current);
            });
        }
    }, []);

    return (
        <div className="MobileCalloutNodeViewIcon CalloutNodeViewIcon" onClick={stopDefaultAndPropagation}>
            <div className="trigger" contentEditable={false} onClick={onEmojiClick}>
                <div className={classNames('callout-icon-wrapper', { active: sheetProps.isSheetOpen })}>
                    <EmojiImage emojiCode={node.attrs.iconCode} size={18} />
                </div>
            </div>
            <MobileCalloutEmojiSheet
                sheetProps={sheetProps}
                selectedEmojiId={node.attrs.iconCode}
                onSelectEmoji={onSelectEmoji}
                closeSheet={dispatchCloseSheet}
            />
        </div>
    );
};

export default MobileCalloutNodeViewIcon;
